import { Dialog, Position } from '@blueprintjs/core'
import Flex from './Flex'
import IconButton from './buttons/IconButton'

type DialogProps = {
  isOpen?: boolean
  style?: React.CSSProperties
  canEscapeKeyClose?: boolean
  transitionDuration?: number
  isCloseButtonShown?: boolean
  canOutsideClickClose?: boolean
  usePortal?: boolean
  title?: string | React.ReactElement
  className?: string
  icon?: React.ReactElement
  toolbar?: React.ReactElement
  body: React.ReactElement
  footer?: React.ReactElement
  onClose?: () => void
}

const DialogWraper: React.FunctionComponent<DialogProps> = ({
  isOpen = false,
  style = {},
  canEscapeKeyClose = false,
  transitionDuration = 0,
  isCloseButtonShown = false,
  canOutsideClickClose = false,
  usePortal = false,
  title,
  className,
  icon,
  toolbar,
  body,
  footer,
  onClose,
}: DialogProps) => (
  <Dialog
    {...{
      isOpen,
      style,
      className,
      canEscapeKeyClose,
      transitionDuration,
      canOutsideClickClose,
      usePortal: true,
      onClose,
    }}
  >
    {(title || toolbar || isCloseButtonShown) && (
      <div className="bp4-dialog-header">
        {icon && <span className="bp4-icon-large bp4-icon-inbox">{icon}</span>}
        <Flex className="w-full" justify="space-between">
          <h5 className="bp4-heading">{title}</h5>
          {isCloseButtonShown && (
            <IconButton
              style={{ height: 30, minHeight: 20 }}
              round
              minimal
              large
              iconName="times"
              tooltip="Close"
              tooltipPosition={Position.LEFT}
              onClick={() => {
                onClose?.()
              }}
            />
          )}
        </Flex>
        <div>{toolbar}</div>
      </div>
    )}
    <div className="bp4-dialog-body">{body}</div>
    {footer && (
      <div className="bp4-dialog-footer">
        <div className="bp4-dialog-footer-actions">{footer}</div>
      </div>
    )}
  </Dialog>
)
export default DialogWraper
